// extracted by mini-css-extract-plugin
export default {"settings":"SettingsPage_settings__VMm8h","flex":"SettingsPage_flex__pn9KP","item":"SettingsPage_item__-oqjc","active":"SettingsPage_active__j5bde"};